module.exports = __webpack_public_path__ + "static/media/rules.0fc930b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/rules.png
// module id = 1263
// module chunks = 0